<header class="app-topbar">
    <div class="container-fluid topbar-menu">
        <div class="d-flex align-items-center gap-2">
            <!-- Topbar Brand Logo -->
            <div class="logo-topbar">
                <!-- Logo light -->
                <a routerLink="/" class="logo-light">
                    <span class="logo-lg">
                        <img src="assets/images/logo.png" alt="logo">
                    </span>
                    <span class="logo-sm">
                        <img src="assets/images/logo-sm.png" alt="small logo">
                    </span>
                </a>

                <!-- Logo Dark -->
                <a routerLink="/" class="logo-dark">
                    <span class="logo-lg">
                        <img src="assets/images/logo-big.png" alt="dark logo">
                    </span>
                    <span class="logo-sm">
                        <img src="assets/images/logo-sm.png" alt="small logo">
                    </span>
                </a>
            </div>

            <!-- Sidebar Menu Toggle Button -->
            <button (click)="toggleSidebar()" class="sidenav-toggle-button btn btn-primary btn-icon">
                <ng-icon name="tablerMenu4" class="fs-22" />
            </button>


        </div>

        <div class="d-flex align-items-center gap-2">
            <!-- Language Dropdown -->
            <app-language-dropdown />

            <!-- Button Trigger Customizer Offcanvas -->
            <!-- <app-customizer-toggler /> -->

            <!-- Light/Dark Mode Button -->
            <!-- <app-theme-toggler /> -->

            <!-- User Dropdown -->
            <app-user-profile-topbar />

        </div>
    </div>
</header>
